import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {getFormValues} from 'redux-form';
import MetricsFilter from './metrics/MetricsFilter';
import MetricsTable from './metrics/MetricsTable';
import {FormattedMessage} from 'react-intl';

import * as analyticsActions from '../../actions/analytics/analyticsActions';
import * as spinnerActions from '../../actions/spinnerActions';

const DEFAULT_TABLE_PARAMS = {page: 1, onPage: 5};

class MetricsContainer extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.labels = {
            language: <FormattedMessage
                id="analytics.metrics.language"
                defaultMessage="Language"
            />,
            //category: 'Category',
            documentPath: <FormattedMessage
                id="analytics.metrics.page"
                defaultMessage="Page"
            />,
            documentTitle: <FormattedMessage
                id="analytics.metrics.title"
                defaultMessage="Title"
            />,
            tags: <FormattedMessage
                id="analytics.metrics.tags"
                defaultMessage="Tags"
            />,
            browser: <FormattedMessage
                id="analytics.metrics.browser"
                defaultMessage="Browser"
            />,
            os: <FormattedMessage
                id="analytics.metrics.os"
                defaultMessage="Operating system"
            />,
            encoding: <FormattedMessage
                id="analytics.metrics.encoding"
                defaultMessage="Encoding"
            />,
            deviceNadeviceme: <FormattedMessage
                id="analytics.metrics.deviceName"
                defaultMessage="Device name"
            />,
            screenResolution: <FormattedMessage
                id="analytics.metrics.screenResolution"
                defaultMessage="Screen resolution"
            />,
        };

        this.metricsFilterValue = 'documentPath';

        this.onFilterChange = this.onFilterChange.bind(this);
        this.loadMetrics = this.loadMetrics.bind(this);
    }

    componentDidMount() {
        this.props.actions.resetMetricsTable();
    }

    componentDidUpdate(prevProps) {
        if(this.objectValuesChanged(prevProps.filterValues, this.props.filterValues)) {
            this.props.actions.resetMetricsTable();
            this.loadMetrics(DEFAULT_TABLE_PARAMS);
        }
    }

    objectValuesChanged(oldValues, newValues) {
        return JSON.stringify(oldValues) !== JSON.stringify(newValues)
    }

    onFilterChange(value) {
        this.metricsFilterValue = value;
        this.props.actions.resetMetricsTable();
        this.loadMetrics(DEFAULT_TABLE_PARAMS);
    }

    loadMetrics(additionalParams) {
        let params = {...this.props.filterValues};
        params.groupBy = this.metricsFilterValue;
        params.context = this.props.context;
        return this.props
            .actions
            .loadAnalytics({...params, ...additionalParams}, 'metrics')
    }

    getTableValueLabel() {
        switch (this.props.filterValues.type) {
            case 'click':
                return <FormattedMessage
                    id="analytics.metrics.tableValueLable"
                    defaultMessage="Clicks count"
                />;
            default:
                return <FormattedMessage
                    id="analytics.metrics.viewsCount"
                    defaultMessage="Views count"
                />;
        }
    }

    render() {

        return (
            <div>
                <div className="row">
                    <div className="col-lg-4 mb-4">
                        <MetricsFilter
                            onFilterChange={this.onFilterChange}
                            labels={this.labels}
                            eventType={this.props.filterValues.type}
                            analyticType={this.props.filterValues.analyticType}
                        />
                    </div>
                    <div className="col-lg-8">
                        <MetricsTable
                            metrics={this.props.metrics}
                            keyName={this.labels[this.metricsFilterValue]}
                            loadMetrics={this.loadMetrics}
                            valueName={this.getTableValueLabel()}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        metrics: state.metrics
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(
            Object.assign(
                {},
                analyticsActions,
                spinnerActions,
            ), dispatch)
    }

}

export default connect(mapStateToProps, mapDispatchToProps)(MetricsContainer);


// WEBPACK FOOTER //
// ./web/src/components/analytics/MetricsContainer.jsx